// extracted by mini-css-extract-plugin
module.exports = {"hero_image":"HeroImage_hero_image__z0HZS","hero_content":"HeroImage_hero_content__1Qq9o"};